"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastTypes = exports.toastSizes = void 0;
exports.toastSizes = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
exports.toastTypes = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
};
